import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IBaselinesService } from "@shared/interfaces/baselines-service.interface";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import {
  BaselineDto,
  CreateBaselineDto,
  UpdateBaselineDto,
} from "@shared/types/baselines/baselines.dto";
import { ApiResponse } from "@shared/types/api-response";

@appInjectable()
export class BaselinesService extends BaseService implements IBaselinesService {
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  create: IBaselinesService["create"] = async (dto: CreateBaselineDto) => {
    const { data } = await this.httpClient.post<ApiResponse<BaselineDto>>(
      "/baselines",
      {
        ...dto,
      },
      {
        baseURL: this.baseURL,
      },
    );

    return data.data;
  };

  list: IBaselinesService["list"] = async () => {
    const { data } = await this.httpClient.get<any>("/baselines", {
      baseURL: this.baseURL,
    });

    return data.data; // Now returns simple array
  };

  saveAll: IBaselinesService["saveAll"] = async (items) => {
    const { data } = await this.httpClient.post<any>(
      "/baselines/bulk",
      { items },
      { baseURL: this.baseURL },
    );
    return data.data;
  };

  update: IBaselinesService["update"] = async (dto: UpdateBaselineDto) => {
    const { data } = await this.httpClient.patch<any>(
      `/baselines/${dto.id}`,
      { ...dto },
      { baseURL: this.baseURL },
    );
    return data.data;
  };

  delete: IBaselinesService["delete"] = async (id: string) => {
    await this.httpClient.delete(`/baselines/${id}`, { baseURL: this.baseURL });
  };
}
